module.exports = __webpack_public_path__ + "static/media/team.4789a714.png";